import { PromptProps } from "../../types/ai/api";
import { ChatDataProps } from "../../types/backend/SengiLabsTypes";

export const parseResponseToChatDataProps = (replyContent:string) => {
    let parsedContent: ChatDataProps[] = [];
    let position = 0;
    const codeRegex = /```(\w+)?\n([\s\S]*?)```/g;
    let lastIndex = 0;
    let match;
    while ((match = codeRegex.exec(replyContent)) !== null) {
      const [fullMatch, lang, code] = match;
      // add text
      if (match.index > lastIndex) {
        const textChunk = replyContent.substring(lastIndex, match.index).trim();
        if (textChunk) {
          parsedContent.push(
            ...detectInlineElements(textChunk, position)
          );
          position = parsedContent.length; 
        }
      }

    // add coding blocks
    const codeType = lang === "mermaid" ? "mermaid" : "code";

    parsedContent.push({
      type: codeType,
      element: code.trim(),
      codeClass: lang && codeType === "code" ? lang : undefined,
      position: parsedContent.length
    });

    lastIndex = match.index + fullMatch.length;
    position = parsedContent.length;
  }

  // Resttext nach letztem Codeblock
  if (lastIndex < replyContent.length) {
    const tail = replyContent.substring(lastIndex).trim();
    if (tail) {
      parsedContent.push(
        ...detectInlineElements(tail, position)
      );
    }
  }
    return parsedContent.map((b, i) => ({ ...b, position: i }));
  };

export const detectInlineElements = (text: string, startPos: number): ChatDataProps[] => {
    const blocks: ChatDataProps[] = [];

    // URLs erkennen
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    let lastIndex = 0;
    let match;
    let posOffset = startPos;

    while ((match = urlRegex.exec(text)) !== null) {
        const url = match[0];

        // Text vor URL
        if (match.index > lastIndex) {
        const before = text.substring(lastIndex, match.index).trim();
        if (before) {
            blocks.push({
            type: "text",
            element: before,
            position: posOffset++
            });
        }
        }

        // URL klassifizieren
        blocks.push({
        type: classifyURL(url),
        element: url,
        position: posOffset++
        });

        lastIndex = match.index + url.length;
    }

    // Resttext
    if (lastIndex < text.length) {
        const rest = text.substring(lastIndex).trim();
        if (rest) {
        blocks.push({
            type: "text",
            element: rest,
            position: posOffset++
        });
        }
    }

    return blocks;
};

export const classifyURL = (url: string) => {
    const lower = url.toLowerCase();

    if (/\.(png|jpg|jpeg|gif|webp|svg)$/.test(lower)) return "image";
    if (/\.(mp4|webm|ogg)$/.test(lower)) return "video";
    if (lower.endsWith(".pdf")) return "pdf";

    if (lower.includes("youtube.com") || lower.includes("youtu.be") || lower.includes("vimeo.com"))
        return "video";

    return "text"; // fallback
};

export const normalizeLLMResponse = (
    raw: unknown
): string => {
    if (raw == null) return "";

    let text =
        typeof raw === "string"
            ? raw
            : JSON.stringify(raw);

    text = text.trim();

    // remove markdown code blocks
    text = text
        .replace(/^```json\s*/i, "")
        .replace(/^```\s*/i, "")
        .replace(/```$/i, "")
        .trim();

    // normalize escaped line breaks if response is double escaped
    text = text
        .replace(/\\n/g, "\n")
        .replace(/\\t/g, "\t")
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, "\\");

    return text.trim();
};

export const parsePromptResponse = (value: unknown): PromptProps | null => {
    try {
        return typeof value === "string"
            ? JSON.parse(value) as PromptProps
            : value as PromptProps;
    } catch (err) {
        console.error("Could not parse generationLLM:", value, err);
        return null;
    }
};